var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeSearch = function SvgHomeSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 50,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#home-search_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 19.89c0-.474.216-.921.586-1.216L23.03.774a1.556 1.556 0 0 1 1.94 0l22.444 17.9c.37.295.586.742.586 1.216v28.554c0 .86-.696 1.556-1.556 1.556H1.556C.696 50 0 49.304 0 48.444z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.304 17.543c-5.39 0-9.761 4.37-9.761 9.761s4.37 9.761 9.761 9.761a9.72 9.72 0 0 0 5.909-1.991l6.51 6.51 1.861-1.861-6.51-6.51a9.72 9.72 0 0 0 1.991-5.909c0-5.39-4.37-9.761-9.761-9.761m-7.129 9.761a7.129 7.129 0 1 1 14.258 0 7.129 7.129 0 0 1-14.258 0",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "home-search_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v50H0z"
  })))));
};
export default SvgHomeSearch;